import { Autocomplete, TextField } from "@mui/material";
import {
  getInputLabelProps,
  getInputProps,
  getAutocompleteInputProps,
} from "../../common/appStyles";

export default function Combobox({
  id,
  handleValueChange,
  fieldValue,
  fieldOptions,
  fieldLabel,
  popperFullWidth,
  customOptionLabel,
  disabled,
  optionFilter,
  isRequired,
  dotUseFullWidth,
  onkeyUp,
  customSx,
}) {
  return (
    <Autocomplete
      sx={customSx}
      inputlabelprops={getInputLabelProps()}
      inputprops={getInputProps()}
      size="small"
      fullWidth={!dotUseFullWidth}
      onChange={(e, value) => {
        handleValueChange(value);
      }}
      id={id}
      value={fieldValue}
      disabled={disabled}
      options={fieldOptions}
      getOptionLabel={customOptionLabel ?? ((option) => option?.Name ?? "")}
      isOptionEqualToValue={
        optionFilter ?? ((option, value) => option?.Id === value?.Id)
      }
      PopperComponent={popperFullWidth}
      renderInput={(params) => (
        <TextField
          {...params}
          required={isRequired}
          InputProps={getAutocompleteInputProps(params.InputProps)}
          size="small"
          InputLabelProps={getInputLabelProps()}
          label={fieldLabel}
          onKeyDown={onkeyUp}
        />
      )}
    />
  );
}
